var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#upload-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.4 10.3571H8.99V15.1785C8.99 15.7089 9.44 16.1428 9.99 16.1428H13.99C14.54 16.1428 14.99 15.7089 14.99 15.1785V10.3571H16.58C17.47 10.3571 17.92 9.31565 17.29 8.70815L12.7 4.28206C12.31 3.90598 11.68 3.90598 11.29 4.28206L6.7 8.70815C6.07 9.31565 6.51 10.3571 7.4 10.3571ZM5 19.0357C5 19.5661 5.45 20 6 20H18C18.55 20 19 19.5661 19 19.0357C19 18.5053 18.55 18.0714 18 18.0714H6C5.45 18.0714 5 18.5053 5 19.0357Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a52e853f6f3ac4f5b42c0656ac44d87d.svg";
export { ForwardRef as ReactComponent };